import React from "react";
import { Col, FormLabel, Row } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { RestReportBean } from "../ds/client_ds.js";
import {
  InventorySalesPurchasePositionCriteriaBean,
  SalesPurchasePositionCriteriaBeanRequest,
} from "../ds/ds.js";
import {
  InputTextbox,
  ProgressBar,
  ShowError,
  ColumnDefinition
} from "../gui_components/UIComponents.js";
import { isEmptyArray, isEmptyString } from "../gui_components/Util";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import { ReportService } from "../services/ReportService.js";
import CustomTable from "../gui_components/CustomTable.js";
class FabricStyleInventoryPosition extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "FabricStyle Inventory Position Inquiry",
      isShowCriteriaView: true,
      isShowPopup: false,
      inquiryDataList: [],
      criteria: new InventorySalesPurchasePositionCriteriaBean(),
      isShowPDFButton: false,
      isShowExcelButton: false,
      error_list: [],
      progressLoadingText: "",
      isShowProgressBarPopup: "",
      is3PL: false,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    if (
      this.props.fabricStyleCode !== "" &&
      this.props.fabricStyleCode !== undefined
    ) {
      let temp_Criteria = this.state.criteria;
      temp_Criteria.fabricStyleCode = this.props.fabricStyleCode;
      this.setState({
        criteria: temp_Criteria,
        isShowCriteriaView: false,
      });
      this.loadPage();
    }
  }
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ errorList: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadPage = () => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.loadItemInventoryPosition(criteria);
  };
  loadItemInventoryPosition = (criteria) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Fetching",
    });
    ReportService.inquireInventorySalesPurchasePositionResult(
      criteria,
      this.loadResponse,
      this.errorCallBack
    );
  };
  loadResponse = (response) => {
    if (response.data != null && response.data.result != null) {
      let inquiryDataList = [];
      if (!isEmptyArray(response.data.result.skuInfos)) {
        inquiryDataList = response.data.result.skuInfos;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        inquiryDataList: inquiryDataList,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateExcel = () => {
    this.downloadReport(2, this.state.criteria);
  };
  generatePDF = () => {
    this.downloadReport(1, this.state.criteria);
  };
  downloadReportResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  downloadReport = (reportType, criteria) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating...",
    });
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let requestInput = new SalesPurchasePositionCriteriaBeanRequest();
    requestInput.criteria = criteria;
    requestInput.reportBean = reportBean;
    ReportService.generateInventorySalesPurchasePositionReport(
      requestInput,
      this.downloadReportResponse,
      this.errorCallBack
    );
  };
  closeAlertProgressBarModalCallBack = (isShowPopup) => {
    this.setState({
      isShowProgressBarPopup: isShowPopup,
    });
  };
  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item " : "FabricStyle",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left", "8", "", "wt-6", "wt-6")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SKU#", "skuNumber", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "inventoryUOMCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
   
    columns.push(
      new ColumnDefinition()
        .setDetails("OnHandQty", "totalOnHandQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Vendor OnOrderQty", "totalVendorOnOrderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
  
    return columns;
  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    return (
      <div>
        <BaseInquiryToolBar
         pageTitle={
          this.state.is3PL
            ? "Item Inventory Position Inquiry"
            : "FabricStyle Inventory Position Inquiry"
        }
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
        />
        <ProgressBar
          closeAlertModalCallBack={this.closeAlertProgressBarModalCallBack}
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <Row>
          <Col sm="1">
            <FormLabel>CompanyCode</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox value={this.companyCode} disabled={true} />
          </Col>
          <Col sm="1">
            {this.state.is3PL ? (
              <FormLabel>Item</FormLabel>
            ) : (
              <FormLabel>FabricStyle</FormLabel>
            )}
          </Col>
          <Col sm="2">
            <InputTextbox value={this.props.fabricStyleCode} disabled={true} />
          </Col>
        </Row>
        <div className="mt-3">
          <CustomTable
            data={inquiryDataList}
            columns={this.inquiryColumns()}
          />
        </div>
      </div>
    );
  }
}
function FabricStyleInventoryPositionInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <FabricStyleInventoryPosition {...props} name="" /> <br />
    </div>
  );
}

export default FabricStyleInventoryPositionInquiry;
